<template>
  <div class="inner" id="printTest">
    <span class="head">{{ cardData.type_name }}</span>
    <div class="center">
      <div class="left">
        <div class="info">
          <p></p>
          <p>姓名：{{ cardData.user_name1 }}</p>
          <p>考号：{{ cardData.exam_no }}</p>
          <p>身份证号：{{ cardData.idcard }}</p>
          <p>报考职位：{{ cardData.signup_job }}</p>
        </div>
        <div class="prompt">
          <p>{{ cardData.exam_info }}</p>
          <p>考场：{{ cardData.room_name }}</p>
          <p>地址：{{ cardData.room_address }}</p>
        </div>
      </div>
      <div class="right">
        <div class="photo">
          <img :src="cardData.photo" alt="" />
        </div>
        <div class="test">
          <span class="title">考试须知</span>
          <div class="testKnow">
            <p :key="index" v-for="(item, index) in examTipList">{{ item }}</p>
          </div>
        </div>
      </div>
    </div>
    <div class="under">
      <span>{{ cardData.addition_info }}</span>
    </div>
  </div>
</template>
<script>
export default {
  name: 'Print',
  data() {
    return {
      cardData: {
        user_name1: '',
        exam_no: '',
        room_address: '',
        room_name: '',
        idcard: '',
        addition_info: '',
        type_name: '',
        exam_info: '',
        exam_tip: ''
      },
      examTipList: []
    }
  },
  created() {
    this.getCardApi()
  },
  methods: {
    // 获取准考证Api
    async getCardApi() {
      let id = this.$route.query.signupid
      const { data: res } = await this.$axios.post('api/signup/Print?signupid=' + id)
      console.log(res)
      if (res.response_code == 200) {
        this.cardData = res.data[0]
        this.cardData.photo = JSON.parse(res.data[0].photo)
        this.cardData.photo = this.cardData.photo[0]
        this.examTipList = this.cardData.exam_tip.split(/[\n,]/g)
      } else {
        this.$message({
          type: 'error',
          message: res.response_msg,
          offset: 300
        })
      }
    }
  }
}
</script>
<style lang="scss" scoped>
@import '../assets/style/mixin.scss';
.inner {
  @include autoInner();
  width: 860px;
  padding: 80px 80px 0px 80px;
  text-align: center;
  .head {
    font-size: 40px;
    font-weight: 700;
  }
  .center {
    display: flex;
    justify-content: space-between;
    margin-top: 100px;
    .left {
      width: 426px;
      text-align: left;
      .info {
        p {
          font-size: 24px;
          font-weight: bold;
          height: 50px;
        }
      }
      .prompt {
        padding-left: 4px;
        p {
          font-size: 14px;
          line-height: 18px;
        }
      }
    }
    .right {
      display: flex;
      justify-content: space-between;
      width: 50%;
      .photo {
        width: 150px;
        height: 180px;
        border: 2px solid #ccc;
        img {
          width: 100%;
          height: 100%;
        }
      }
      .test {
        width: 254px;
        .testKnow {
          text-align: left;
          height: 250px;
          // display: flex;
          // flex-direction: column;
          // align-items: space-between;
          p {
            font-size: 14px;
            line-height: 18px;
          }
        }
        .title {
          display: block;
          font-size: 16px;
          font-weight: 700;
          height: 21px;
          line-height: 21px;
        }
      }
    }
  }
  .under {
    margin: 0 auto;
    margin-top: 90px;
    width: 760px;
    height: 110px;
    border: 2px solid #000;
    display: flex;
    justify-content: center;
    align-items: center;
    span {
      display: block;
      width: 468px;
      font-size: 18px;
      line-height: 24px;
      font-weight: 700;
    }
  }
}
</style>
